import { render, staticRenderFns } from "./strandTable.vue?vue&type=template&id=72743e33&scoped=true&"
import script from "./strandTable.vue?vue&type=script&lang=js&"
export * from "./strandTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72743e33",
  null
  
)

export default component.exports